export default class MipMap {
	constructor(drawable) {
		this.drawable = drawable;
		this.canvas = document.createElement("canvas");
		this.context = this.canvas.getContext("2d");

		this.w = drawable.width;
		this.h = drawable.height;

		if (drawable instanceof Image) {
			this.w = drawable.naturalWidth;
			this.h = drawable.naturalHeight;
		}

		this.canvas.width = this.w << 1;
		this.canvas.height = this.h << 1;

		this.context.drawImage(this.drawable, 0, 0);

		let x0 = 0;
		let x1 = this.w;
		let y0 = 0;
		let y1 = this.h;

		let w0 = this.w;
		let w1 = this.w >> 1;
		let h0 = this.h;
		let h1 = this.h >> 1;
		while (w1 > 1) {
			this.context.drawImage(this.canvas, x0, y0, w0, h0, x1, y0, w1, h0);
			x0 = x1;
			x1 += w1;
			w0 = w1;
			w1 >>= 1;
		}

		x0 = 0;
		while (h1 > 1) {
			this.context.drawImage(this.canvas, x0, y0, x1, h0, x0, y1, x1, h1);
			y0 = y1;
			y1 += h1;
			h0 = h1;
			h1 >>= 1;
		}
	}

	draw(context, ...coords) {
		if (!(context instanceof CanvasRenderingContext2D))
			throw new Error("First argument must be CanvasRenderingContext2D.");

		let tw = this.w;
		let th = this.h;

		let sx = 0;
		let sy = 0;
		let sw = tw;
		let sh = th;
		let dx = 0;
		let dy = 0;
		let dw = tw;
		let dh = th;

		switch (coords.length) {
			case 0:
				break;
			case 2:
				[dx, dy] = coords;
				break;
			case 4:
				[dx, dy, dw, dh] = coords;
				break;
			case 8:
				[sx, sy, sw, sh, dx, dy, dw, dh] = coords;
				break;
			default:
				throw new Error("Invalid argument count.");
		}

		const aw = (dw * tw) / sw;
		const ah = (dh * th) / sh;

		let x = 0;
		while (tw > aw * 2) {
			x += tw;
			tw >>= 1;
		}

		let y = 0;
		while (th > ah * 2) {
			y += th;
			th >>= 1;
		}

		let scaleX = tw / this.w;
		let scaleY = th / this.h;

		sx = x + sx * scaleX;
		sy = y + sy * scaleY;

		sw *= scaleX;
		sh *= scaleY;

		context.drawImage(this.canvas, sx, sy, sw, sh, dx, dy, dw, dh);
	}
}
